export default function getStreamPlaylistWithOffset({ playlist, offset }) {
  const url = new URL(playlist, window.location.origin);
  url.searchParams.append("shift", offset);
  return url.href;
}
